import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  height: 100%;
  width: 100vw;
  .extra-container {
    width: 80%;
    padding: 1rem;
    margin: 1rem auto;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }
  @media only screen and (min-width: 867px) {
  }
`;
